import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { clearSuspended } from './store/actions'
import { useDispatch } from 'react-redux'

export const useSuspendStatus = () => {
  const dispatch = useDispatch()
  const suspendStatus = useSelector(R.path(['auth', 'suspendStatus']))
  const clearSuspendStatus = () => dispatch(clearSuspended())

  return { suspendStatus, clearSuspendStatus }
}
